import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Card, Form, Input, Button, message, Image } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import '../styles/Login.css';
import background from '../images/background5.jpg';

export const Login = () => {
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setError('');
    const result = await login(values.dsemail, values.dspassword);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        height: '100vh',
      }}
    >
      <Card style={{ width: 300, boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.2)', backgroundColor: '#001529'}}>
        <div className='logo-text' style={{ padding: 16, color: '#fff', textAlign: 'center', fontWeight: 'bold', fontSize: 35 }}>
          ZETEK
        </div>

        {error && (
          <div style={{ color: 'red', textAlign: 'center', marginBottom: 8 }}>
            {error}
          </div>
        )}

        <Form name="login" onFinish={onFinish}>
          <Form.Item
            name="dsemail"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email address!' },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Email"
            />
          </Form.Item>
          <Form.Item
            name="dspassword"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{backgroundColor: "#003465"}} block>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};